<template>
  <div id="group_search_outer">
    <div style="text-align: center;">
      <v-autocomplete
      :items="items"
      v-model="item"
      :min-len="2"
      :get-label="getLabel"
      :keep-open="keepOpen"
      v-bind:placeholder="'一键加入团体'"
      @update-items="updateItems"
      @item-clicked="selectedItem"
      @focus="searchFocus"
      @blur="searchBlur"
      :component-item="template"></v-autocomplete>
    </div>
    <input v-show="item != null" class="per_item_button" type="button" value="申请加入" @click="submitItem">
  </div>
</template>

<script>
import GroupSearchItem from "./GroupSearchItem";
// import VAutocomplete from "v-autocomplete";
import VAutocomplete from '../autocomplete/Autocomplete';
// import 'v-autocomplete/dist/v-autocomplete.css'
export default {
  name: "GroupSearch",
  components: {
    GroupSearchItem,
    VAutocomplete
  },
  data() {
    return {
      item: null,
      template: GroupSearchItem,
      items: null,
      keepOpen: false,
      inputAttrs: {
        class: [
          {
            color: '#ff0000',
          }
        ]
      }
    }
  },
  computed: {

  },
  mounted() {
  },
  methods: {
    updateItems(text) {
      let _this = this;
      if (text == null || text == '') {
        this.items = null;
        return;
      }
      // console.log(text);
      // let keyword = encodeURI(text);
      let keyword = text;
      let params = {
        keyword: keyword,
        pageIndex: 1,
        size: 20
      };
      // console.log(keyword);
      this.$store.state.http.ajax.ucTeamsFind(params,function (data) {
        // console.log(data);
        if (data.code == 0) {
          _this.items = data.data;
        }
      }, null);
    },
    getLabel(item) {
      if (item == null) {
        return '';
      }
      return item.text;
    },
    selectedItem(item) {
      this.keepOpen = false;
    },
    submitItem() {
      let item = this.item;
      this.$emit('searchItem', {
        item
      });
    },
    searchFocus() {
      this.keepOpen = true;
    },
    searchBlur() {
      this.keepOpen = false;
    }
  },
}
</script>

<style scoped>

  #group_search_outer {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }

  #group_search_outer > div:first-child {
    width: 70%;
    max-width: 300px;
  }

  #group_search_outer .per_item_button {
    outline: none;
    margin-left: 5%;
    width: 90px;
    border: none;
    border-radius: 15px;
    font-size: 1rem;
    height: 25px;
    color: white;
    background-color: #cbb042;
  }




</style>



// WEBPACK FOOTER //
// src/components/personal/GroupSearch.vue